// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"editor-icon_wrapper__TyjL0","container":"editor-icon_container__1v936","camera":"editor-icon_camera__jqaBg","icon":"editor-icon_icon__p0O-E"};